function toggleVideoPlay(element) {
    const youtubeEmbed = element.querySelector('.youtube-embed');
    const videoOverlay = document.getElementById('videoOverlay');
    const videoContainer = document.getElementById('videoContainer');
    const body = document.body;

    if (youtubeEmbed) {
      const videoId = youtubeEmbed.dataset.videoId;
      videoContainer.innerHTML = `
        <iframe src="https://www.youtube.com/embed/${videoId}?autoplay=1"
                frameborder="0"
                allowfullscreen
                allow="autoplay"></iframe>
      `;
      videoOverlay.style.display = "flex";
      body.classList.add('no-scroll');
    } else {
      const video = element.querySelector('.custom-video');
      if (video) {
        videoContainer.innerHTML = `
          <video controls autoplay class="fullscreen-video">
            <source src="${video.src}" type="video/mp4">
          </video>
        `;
        videoOverlay.style.display = "flex";
        body.classList.add('no-scroll');
      }
    }
  }

  function closeVideo() {
    const videoOverlay = document.getElementById('videoOverlay');
    const videoContainer = document.getElementById('videoContainer');
    const body = document.body;
    const video = videoContainer.querySelector('video');
    if (video) video.pause();

    videoContainer.innerHTML = '';

    videoOverlay.style.display = "none";
    body.classList.remove('no-scroll');
  }

  document.getElementById('videoOverlay').addEventListener('click', function(e) {
    if (e.target === this) {
      closeVideo();
    }
  });